import CountryAutocomplete from "components/CountryAutocomplete";
import AddressAutocomplete from "components/shared/AddressAutocomplete";
import TextFormComponent from "components/shared/FormComponent/TextFormComponent";
import { useTranslation } from "react-i18next";

import type { ITransfereeFormData } from "..";

interface IAddressStep {
    useFormData: ITransfereeFormData;
    stepTitle: string;
    stepSubtitle: string;
    indexStep: number;
}

/**
 * Second step of TransfereeForm.
 */
const AddressStep = ({ useFormData, stepTitle, stepSubtitle, indexStep }: IAddressStep) => {
    const [t] = useTranslation();
    const { control, errors, setValue, watch } = useFormData;
    return (
        <>
            <h3 className="form-section-title">
                {indexStep + 1}. {stepTitle}
            </h3>
            <span className="form-section-description">{stepSubtitle}</span>
            <div className="form-fields">
                <AddressAutocomplete
                    control={control}
                    error={errors.name}
                    setValue={setValue}
                    streetValue={watch("street")}
                />
                <div className="joined-fields">
                    <TextFormComponent
                        label={t("NewBeneficiary.ZIPCode")}
                        control={control}
                        controlName="zipCode"
                        error={errors.name}
                        placeholder={t("AddressPlaceholders.ZipCode")}
                    />
                    <TextFormComponent
                        label={t("NewBeneficiary.City")}
                        control={control}
                        controlName="city"
                        error={errors.name}
                        placeholder={t("AddressPlaceholders.City")}
                    />
                </div>
                <CountryAutocomplete control={control} errors={errors} />
            </div>
        </>
    );
};

export default AddressStep;
